<template>
  <Card>
    <p slot="title">一物一码破损列表</p>
    <template slot="extra">
      <Button type="primary" icon="md-cloud-upload" @click="exportAction()"
        >报表导出</Button
      >
      <Button type="primary" icon="ios-search" @click="handleSearch()"
        >查询</Button
      >
      <Button type="primary" icon="md-sync" @click="reset()">刷新</Button>
    </template>
    <Row>
      <Col span="24">
        <Input
          v-model="params.qrCode"
          placeholder="请输入二维码编码"
          class="public-inp"
        />
        <DatePicker
          type="daterange"
          :options="options"
          placement="bottom-start"
          placeholder="请选择申诉时间"
          v-model="seTime"
          class="public-inp"
        ></DatePicker>
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ index }" slot="sort">
            {{ (params.pageNum - 1) * params.pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="toDetail(row)">查看</a>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="params.pageSize"
          :current="params.pageNum"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>

<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "物料名称",
    key: "name",
    width: 100,
  },
  {
    title: "渠道",
    key: "channelCode",
    width: 100,
  },
  {
    title: "品牌",
    key: "brandCode",
    width: 100,
  },
  {
    title: "批次号",
    key: "batchNumber",
    width: 100,
  },
  {
    title: "基础码",
    key: "qrBaseCode",
    width: 100,
  },
  {
    title: "二维码编码",
    key: "qrCode",
    width: 100,
  },
  {
    title: "申诉人",
    key: "srName",
    width: 100,
  },
  {
    title: "申诉类型",
    key: "appealType",
    width: 100,
    render(h, params) {
      // 码破损、码丢失、物料丢失
      let s = params.row.appealType,
        t = "";
      switch (s) {
        case "1":
          t = "码破损";
          break;
        case "2":
          t = "码丢失";
          break;
        case "3":
          t = "物料丢失";
          break;
        default:
          t = "";
      }
      return h("span", t);
    },
  },
  {
    title: "申诉原因",
    key: "appealReason",
    width: 100,
  },
  {
    title: "申诉时间",
    key: "appealTime",
    width: 100,
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
export default {
  data() {
    return {
      options,
      params: {
        qrCode: "",
        appealTimeBegin: "",
        appealTimeEnd: "",
        pageNum: 1,
        pageSize: 10,
      },
      seTime: [],
      total: 0,
      columns,
      tbList: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str, true);
    },
    getList() {
      this.loading = true;
      let params = this.params;
      params.appealTimeBegin = this.initTime(this.seTime, 0);
      params.appealTimeEnd = this.initTime(this.seTime, 1);
      this.$api.frmLossList(params).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tbList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.params.pageNum = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    // 重置
    reset() {
      for (let key in this.params) {
        this.params[key] = "";
      }
      this.seTime = [];
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    toDetail(e) {
      this.$router.push({
        path: "frmLossDetail",
        query: {
          code: e.code,
        },
      });
    },
    exportAction() {
      let data = this.params;
      this.$api.frmLossExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/material/frmLossList.vue